import { useEffect, useState } from "react";
import { hasText } from "../../utils/utils";
import { Button, Modal, Radio, RadioChangeEvent } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import CustomRecordDetailModal from "../../components/modal/customRecordDetailModal";
import { AccessLevel, Address, RowLevelAction } from "../../types/types";
import { GetRequest } from "../../utils/api";
import CustomLoader from "../../components/loader";

interface AddressSelectionProps {
    choosenAddress?: Address,
    loanNo: string,
    onSelection: Function,
    onClose: Function
}

const AddressSelection: React.FC<AddressSelectionProps> = ({
    choosenAddress,
    loanNo,
    onSelection,
    onClose
}) => {

    const actualApi = "loan/platform/{version}/api/addressInfoDetails?size=50&page=0&search=loanNo:eq" + loanNo;
    const [loading, setLoading] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string>();
    const [selectedAddress, setSelectedAddress] = useState<Address|undefined>(choosenAddress);
    const [selectedAddressIndex, setSelectedAddressIndex] = useState<number>();
    const [availableAddresses, setAvailableAddresses] = useState<Array<Address>>([]);
    const [visible, setVisible] = useState(false);

    const fetchAvailableAddresses = () => {

           GetRequest(actualApi).then((data:any) => {
                setLoading(false);
                setVisible(true);
                if (data.hasOwnProperty('records')) {
                    setAvailableAddresses(data.records);
                }
            }).catch((err:Error) => {
                setLoading(false);
                setErrorMessage(err?.message);
            });
    }

    useEffect(() => {
        fetchAvailableAddresses();
    }, []);

    useEffect(() => {
        if(choosenAddress){
            availableAddresses.map((address: Address, idx: number) => {
                if(address.addressFrom === choosenAddress.addressFrom){
                    setSelectedAddressIndex(idx);
                }
            });
        }
    }, [choosenAddress, availableAddresses]);

    const handleCancel = () => {
        setVisible(false);
        onClose();
    };

    const handleOk = () => {
        setVisible(false);
        onSelection(selectedAddress);
        onClose();
    };

    const renderNewAddressForm = () => {
        let urlparams: Map<string, string> = new Map();
        urlparams.set("loanNo", loanNo);
        urlparams.set("recordId", loanNo);
        return (
            <CustomRecordDetailModal
                title={"New Address"}
                actionButtonStyle={{ marginTop: '10px' }}
                actionButtonIcon={<PlusOutlined  rev={undefined} />}
                actionButtonType={"default"}
                platformAction={RowLevelAction.CREATEWITHCONTEXT}
                blueprintApi={"loan/platform/api/blueprint/{version}/addNewAddress"}
                actionName={"Add Address"}
                isCreateFlow={false}
                userAccessLevel={"DELETE" as AccessLevel}
                moduleCode={"newInfoUpdate"}
                allowEdits={true}
                urlparams={urlparams}
                onSuccess={() => fetchAvailableAddresses()}
            />
        );
    };

    // const getAddressId = (item: Address): string => {
    //     return item?.addressFrom??getAddressStringByExcludingNulls(item);
    // }

    const getAddressStringByExcludingNulls = (item: Address): string => {
        let val = item?.addressLine1 ?? "";
        if (hasText(item?.addressLine2)) {
            val = val + ", " + item?.addressLine2;
        }
        if (hasText(item?.addressLine3)) {
            val = val + ", " + item?.addressLine3;
        }
        if (hasText(item?.city)) {
            val = val + ", " + item?.city;
        }
        if (hasText(item?.pinCode)) {
            val = val + ", " + item?.pinCode;
        }
        if (hasText(item?.state)) {
            val = val + ", " + item?.state;
        }
        return val;
    };

    const onAddressSelectionChange = (e: RadioChangeEvent) => {
        let index: number = e.target.value;
        // getAddressId(availableAddresses[index])
        setSelectedAddress(availableAddresses[index]);
        setSelectedAddressIndex(index);
    };

    const evenRadioStyle = {
        display: 'block',
        backgroundColor: '#e8e8e8',
        padding: '8px',
    };
    const oddRadioStyle = {
        display: 'block',
        backgroundColor: 'inherit',
        padding: '8px',
    };

    return (<>
        <Modal
            title="Choose Address"
            visible={visible}
            onCancel={handleCancel}
            closable={true} // Show close icon
            footer={[
                <Button key="ok" type="primary" onClick={handleOk}>
                    Use the selected Address
                </Button>
            ]}
        >
            {loading ? (
                <div className="panel-loading">
                    
                    <CustomLoader></CustomLoader>
                </div>
            ) : (
                errorMessage ? (<div> Something went wrong: {errorMessage} </div>) : (
                    availableAddresses.length > 0 ? (
                        <>
                            <Radio.Group onChange={onAddressSelectionChange}
                                value={selectedAddressIndex}>
                                <>
                                    {availableAddresses.map((item: Address, idx: number) => (
                                        <Radio key={idx} style={idx % 2 === 0 ? evenRadioStyle : oddRadioStyle} value={idx}>
                                            <span style={{ marginLeft: "10px" }}>
                                                {getAddressStringByExcludingNulls(item)} (ID: {item.addressFrom})
                                            </span>
                                        </Radio>
                                    ))}
                                </>
                            </Radio.Group>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                {renderNewAddressForm()}
                            </div>
                        </>
                    ) : (
                        <div>
                            <p className="my-3">No Addresses available.</p>
                            {renderNewAddressForm()}
                        </div>
                    )
                )
            )}
        </Modal>
    </>);
};

export default AddressSelection;